<template>
  <div>
    <Detail />
  </div>
</template>

<script>
import LoadingSkeleton from "@/components/generic/LoadingSkeleton";

const Detail = () => ({
  component: import('@/components/center_widgets/Detail'),
  loading: LoadingSkeleton,
  timeout: 200
})

export default {
  name: 'PrematchDetailView',
  components: { Detail },
}
</script>
